import { render, staticRenderFns } from "./bestSellingAdd.vue?vue&type=template&id=316741b6&"
import script from "./bestSellingAdd.vue?vue&type=script&lang=js&"
export * from "./bestSellingAdd.vue?vue&type=script&lang=js&"
import style0 from "./bestSellingAdd.vue?vue&type=style&index=0&id=316741b6&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316741b6')) {
      api.createRecord('316741b6', component.options)
    } else {
      api.reload('316741b6', component.options)
    }
    module.hot.accept("./bestSellingAdd.vue?vue&type=template&id=316741b6&", function () {
      api.rerender('316741b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/SalesStatistics/bestSellingAdd.vue"
export default component.exports